'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faXmark } from '@icons/classic/regular';
import { Button } from './Button';
import { FlexContainer } from './FlexContainer';
import { SheetDescription, SheetHeader, SheetTitle } from './Sheet';
import { SheetContext } from './SheetContext';
import { Label } from '../typography';
interface SheetNavigationHeaderProps {
  bordered?: boolean;
  children?: React.ReactNode;
  description?: string;
  title?: string | React.ReactNode;
  titlePrefix?: React.ReactNode | string;
  /** If provided, shows a back button that invokes this callback. */
  onNavigateBack?: () => void;
  onClose?: () => void;
}
export default function SheetNavigationHeader(t0) {
  const $ = _c(13);
  const {
    children,
    description,
    onNavigateBack,
    onClose,
    title,
    titlePrefix,
    bordered: t1
  } = t0;
  const bordered = t1 === undefined ? true : t1;
  const sheetContext = useContext(SheetContext);
  const contextBack = sheetContext?.canNavigateBack ? sheetContext.navigateBack : undefined;
  const resolvedBack = onNavigateBack ?? contextBack;
  const hasNavigation = resolvedBack || onClose;
  let t2;
  if ($[0] !== title || $[1] !== titlePrefix) {
    t2 = title ? <FlexContainer className="min-w-0 gap-1" direction="column">{typeof titlePrefix === "string" ? <Label className="text-secondary">{titlePrefix}</Label> : titlePrefix}<SheetTitle className="min-w-0 break-words">{title}</SheetTitle></FlexContainer> : null;
    $[0] = title;
    $[1] = titlePrefix;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const titleComponent = t2;
  let t3;
  if ($[3] !== children || $[4] !== description || $[5] !== hasNavigation || $[6] !== onClose || $[7] !== resolvedBack || $[8] !== titleComponent) {
    t3 = hasNavigation ? <><FlexContainer className="w-full" direction="row" items="center" justify="between"><FlexContainer className="min-w-0 gap-3" direction="column" items="center">{resolvedBack && <Button className="self-start p-0 -mt-9" onClick={resolvedBack} size="sm" variant="quaternary"><div className="flex items-center gap-1"><FontAwesomeIcon icon={faArrowLeft} size="xs" />Back</div></Button>}{titleComponent}</FlexContainer>{onClose && <Button className="h-8 w-8 p-0" aria-label="Close sheet" onClick={onClose} size="sm" variant="tertiary"><FontAwesomeIcon className="h-4 w-4" icon={faXmark} /></Button>}</FlexContainer>{description && <SheetDescription size="lg">{description}</SheetDescription>}{children}</> : <>{titleComponent}{description && <SheetDescription size="lg">{description}</SheetDescription>}{children}</>;
    $[3] = children;
    $[4] = description;
    $[5] = hasNavigation;
    $[6] = onClose;
    $[7] = resolvedBack;
    $[8] = titleComponent;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== bordered || $[11] !== t3) {
    t4 = <SheetHeader bordered={bordered}>{t3}</SheetHeader>;
    $[10] = bordered;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}